import { gql } from 'graphql-request';

export const GET_AUDITIONS = gql`
  query ($casting_role_id: ID!, $phase: String!, $status: String!) {
    auditions(castingRoleId: $casting_role_id, phase: $phase, status: $status) {
      id
      sequence_tag
      phase
      priority
      submission_note
      mediumable_count
      status
      updated_at
      profile {
        talent {
          first_name
          last_name
        }
      }
    }
  }
`;
